<template>
  <div id="newDetail">
    <page-header :noBack="true">
      详情
    </page-header>
    <div class="video_wrap" v-if="details.videoUrl">
      <video class="video" :poster="details.coverUrl" :src="details.videoUrl" controls></video>
    </div>
    <div class="new_detail">
      <div class="titles">{{details.title}}</div>
      <div class="time">{{details.source}}&nbsp;&nbsp;{{details.createTime}}</div>
      <div class="details" v-html="details.content"></div>
      <div class="views">{{views}}阅读</div>
      <div class="text" v-if="details.link"><a :href="details.link">阅读原文</a></div>
    </div>
    <div class="adver_wrap" v-if="adverShow && isAdverShow" @click="goAdver">
      <div class="adver_title">{{adver.advertisementname}}</div>
      <div class="adver_content">
        <p class="text" v-if="adver.paceform === 2">{{adver.sourcematerial}}</p>
        <img class="img" v-if="adver.paceform === 0" :src="adver.sourcematerial" alt="">
        <video class="video" v-if="adver.paceform === 1" :src="adver.sourcematerial" autoplay></video>
      </div>
      <div class="adver_bottom" v-if="adverShow && isAdverShow">
        <div class="bottom_left">
          <div class="title">广告</div>
          <div class="name">{{adver.pacename}} · 广告</div>
        </div>
        <div class="close" @click.stop="closeAdver"></div>
      </div>
    </div>
    <!-- <div class="comment_wrap">
      <div class="title">评论</div>
      <div class="lists">
        <div class="list" v-for="(item, index) in comments" :key="index">
          <div class="list_infos">
            <div class="infos">
              <div class="headimgs">
                <img class="headimg" :src="item.headimg" alt="">
              </div>
              <div class="name">{{item.name}}</div>
            </div>
            <div class="dianzan">
              <img class="icon" src="../assets/img/icon_dianzan.png" alt="">
              <span class="num">{{item.num}}</span>
            </div>
          </div>
          <div class="contents">{{item.content}}</div>
          <div class="times">{{item.time}}</div>
        </div>
      </div>
      <div class="public_no_data" v-if="comments.length === 0">暂无评论</div>
      <router-link to="/download" tag="div" class="see_more">查看更多</router-link>
    </div> -->
    <div class="download_wrap">
      <div class="left_wrap">
        <img class="logo" src="../assets/img/logo_1.png" alt="">
        <div class="name">学习国防</div>
      </div>
      <router-link to="/download" tag="div" class="btn">下载App</router-link>
    </div>
  </div>
</template>
<script>
export default {
  name: "newDetail",
  data() {
    return {
      id: this.$route.query.id,
      type: Number(this.$route.query.type),
      details: {},
      adver: {},
      isAdverShow: true,
      comments: [],
    };
  },
  computed: {
    views () {
      if (this.details.views !== undefined) {
        if (this.details.views >= 10000) {
          return (this.details.views / 10000).toFixed(1) + '万'
        } else {
          return this.details.views;
        }
      } else {
        if (this.details.readingVolume >= 10000) {
          return (this.details.readingVolume / 10000).toFixed(1) + '万'
        } else {
          return this.details.readingVolume;
        }
      }
    },
    adverShow () {
      return !!this.adver.id;
    },
  },
  mounted () {
    if (this.type === 1) {
      this.getZhiding();
    } else if (this.type === 2) {
      this.getBanner();
    } else if (this.type === 3) {
      this.getYaowen();
    } else if (this.type === 4) {
      this.getVrBanner();
    } else if (this.type === 5) {
      this.getVrNew();
    } else if (this.type === 6) {
      this.getBingqiBanner();
    } else if (this.type === 7) {
      this.getBingqiNew();
    } else if (this.type === 8) {
      this.getRuwuBanner();
    } else if (this.type === 9) {
      this.getRuwuNew();
    } else if (this.type === 10) {
      this.getRuwuFalv();
    } else if (this.type === 11) {
      this.getLaobingBanner();
    } else if (this.type === 12) {
      this.getLaobingNew();
    } else if (this.type === 14) {
      this.getGuofanghaoNew();
    }
  },
  methods: {
    goAdver () {
      window.location.href = this.adver.adconnection;
    },
    closeAdver () {
      this.isAdverShow = false;
    },
    // 置顶详情 1
    getZhiding () {
      this.axios.post('/xxgf-api/homepage/getHomePageDetail', {
        id: this.id || '82f7394759fe4e97a2bd2bb486525935'
      })
        .then(({data}) => {
          if (data.code === 200) {
            this.details = data.data.detail;
            if (data.data.adver) {
              this.adver = data.data.adver;
            }
          }
        })
    },
    // 轮播详情 2
    getBanner () {
      this.axios.post('/xxgf-api/homepage/getBannerDetail', {
        id: this.id || '13'
      })
        .then(({data}) => {
          if (data.code === 200) {
            this.details = data.data.detail;
            if (data.data.adver) {
              this.adver = data.data.adver;
            }
          }
        })
    },
    // 要闻详情 3
    getYaowen () {
      this.axios.post('/xxgf-api/homepage/getNewsDetail', {
        id: this.id || 13
      })
        .then(({data}) => {
          if (data.code === 200) {
            this.details = data.data.detail;
            if (data.data.adver) {
              this.adver = data.data.adver;
            }
          }
        })
    },
    // VR红色馆轮播图 4
    getVrBanner () {
      this.axios.post('/xxgf-api/homepage/getVrBannerDetail', {
        id: this.id || '069466e1204745788f44a52d65f83757'
      })
        .then(({data}) => {
          if (data.code === 200) {
            this.details = data.data.detail;
            if (data.data.adver) {
              this.adver = data.data.adver;
            }
          }
        })
    },
    // VR红色馆咨询 5
    getVrNew () {
      this.axios.post('/xxgf-api/homepage/getVrredhouseDetail', {
        id: this.id || '5716c981cdc8416a8b477e5654cbff20'
      })
        .then(({data}) => {
          if (data.code === 200) {
            this.details = data.data.detail;
            if (data.data.adver) {
              this.adver = data.data.adver;
            }
          }
        })
    },
    // 兵器banner 6
    getBingqiBanner () {
      this.axios.post('/xxgf-api/homepage/getWeaponryBannerDetail', {
        id: this.id || 'ad687c8549354c9bac8835272bb11a8b'
      })
        .then(({data}) => {
          if (data.code === 200) {
            this.details = data.data.detail;
            if (data.data.adver) {
              this.adver = data.data.adver;
            }
          }
        })
    },
    // 兵器资讯 7
    getBingqiNew () {
      this.axios.post('/xxgf-api/homepage/getWeaponryDetail', {
        id: this.id || '16'
      })
        .then(({data}) => {
          if (data.code === 200) {
            this.details = data.data.detail;
            if (data.data.adver) {
              this.adver = data.data.adver;
            }
          }
        })
    },
    // 应征入伍-轮播图 8
    getRuwuBanner () {
      this.axios.post('/xxgf-api/homepage/joinarmyBanner', {
        id: this.id || '10275d7685e8424db377d65734067310'
      })
        .then(({data}) => {
          if (data.code === 200) {
            this.details = data.data.detail;
            if (data.data.adver) {
              this.adver = data.data.adver;
            }
          }
        })
    },
    // 应征入伍-入伍咨询 9
    getRuwuNew () {
      this.axios.post('/xxgf-api/homepage/joinarmy', {
        id: this.id || 'dc19773da9f94ab6a091853e15774372'
      })
        .then(({data}) => {
          if (data.code === 200) {
            this.details = data.data.detail;
            if (data.data.adver) {
              this.adver = data.data.adver;
            }
          }
        })
    },
    // 应征入伍-法律法规 10
    getRuwuFalv () {
      this.axios.post('/xxgf-api/homepage/getLegislationDetail', {
        id: this.id || '095e1fe593e84fd6ac0321fe4ab37183'
      })
        .then(({data}) => {
          if (data.code === 200) {
            this.details = data.data.detail;
            if (data.data.adver) {
              this.adver = data.data.adver;
            }
          }
        })
    },
    // 老兵之家-banner 11
    getLaobingBanner () {
      this.axios.post('/xxgf-api/homepage/getVeteranhomeBannerDetail', {
        id: this.id || 'dbd6a56bb9b54c52b16df47f1ac546d6'
      })
        .then(({data}) => {
          if (data.code === 200) {
            this.details = data.data.detail;
            if (data.data.adver) {
              this.adver = data.data.adver;
            }
          }
        })
    },
    // 老兵之家-咨询 12
    getLaobingNew () {
      this.axios.post('/xxgf-api/homepage/getVeteranhomeDetail', {
        id: this.id || 'bbcff1bb95b24fbd87ab698254273eff'
      })
        .then(({data}) => {
          if (data.code === 200) {
            this.details = data.data.detail;
            if (data.data.adver) {
              this.adver = data.data.adver;
            }
          }
        })
    },
    // 国防号咨询 14
    getGuofanghaoNew () {
      this.axios.post('/xxgf-api/api/nationaldefense/shareDynamicDetail', {
        id: this.id || '6783c75b7a7b4bc8a4fc326979596200'
      })
        .then(({data}) => {
          if (data.code === 200) {
            this.details = data.data;
          }
        })
    }
  }
};
</script>

<style lang="scss">
#newDetail {
  width: 100%;
  background:#fff;
  padding: 94px 0 30px;
  padding-bottom:120px;
  .video_wrap{
    width:100%;
    height:400px;
    background:#000;
    .video{
      width:100%;
      height:100%;
    }
  }
  .new_detail{
    padding:30px
  }
  .titles{
    font-size:44px;
    line-height:60px;
  }
  .time{
    font-size:24px;
    color:#AAAAAA;
    margin: 20px 0;
  }
  .details{
    overflow: hidden;
    *{
      font-size:30px !important;
      line-height: 60px !important;
    }
    img{
      max-width:100% !important;
      height:auto !important;
    }

  }
  .text{
    a{
      color:blue;
    }
  }
  .views{
    font-size:24px;
    color:#AAAAAA;
  }
  .comment_wrap{
    padding:20px 30px 0;
    .title{
      font-size:38px;
      line-height:80px;
      position: relative;
      padding-left:20px;
      &:after{
        content:'';
        display:block;
        width:8px;
        height:38px;
        background:#D72F1D;
        position:absolute;
        left:0;
        top:50%;
        margin-top:-19px;
      }
    }
    .lists{
      padding-top:30px;
      .list{
        margin-bottom:30px;
        .list_infos{
          display:flex;
          align-items: center;
          justify-content: space-between;
          .infos{
            display:flex;
            align-items: center;
            .headimgs{
              width:80px;
              height:80px;
              border-radius: 50%;
              overflow: hidden;
              margin-right:30px;
              .headimg{
                width:100%;
                height:100%;
                object-fit: cover;
              }
            }
            .name{
              font-size:28px;
              color:#333;
            }
          }
          .dianzan{
            display:flex;
            align-items: center;
            .icon{
              width:60px;
              height:60px;
              margin-right:20px;
            }
            .num{
              font-size:28px;
              color:#666;
            }
          }
        }
        .contents{
          font-size:28px;
          color:#666;
          line-height:40px;
          margin: 20px 0;
          padding-left:110px;
        }
        .times{
          font-size:26px;
          color:#999;
          padding-left:110px;
        }
      }
    }
    .see_more{
      width:400px;
      height:80px;
      background:rgba(178,7,0,1);
      border-radius: 20px;
      line-height:80px;
      text-align:center;
      font-size:28px;
      margin:30px auto;
      color:#fff;
    }
  }
  .adver_wrap{
    padding:30px;
    border-top:20px solid #f5f5f5;
    .adver_title{
      font-size:36px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .adver_content{
      width:100%;
      padding:20px 0;
      .text{
        font-size:30px;
        line-height:50px;
      }
      .img{
        width:100%;
        height:388px;
        border-radius: 16px;
      }
      .video{
        width:100%;
        height:388px;
        border-radius: 16px;
        background:#000;
      }
    }
    .adver_bottom{
      display:flex;
      align-items: center;
      justify-content: space-between;
      .bottom_left{
        display:flex;
        align-items: center;
        .title{
          font-size:24px;
          line-height:35px;
          color:#D8D8D8;
          padding: 0 10px;
          border:1px solid #D8D8D8;
          margin-right:12px;
          border-radius: 4px;
        }
        .name{
          font-size:24px;
          color:#999;
        }
      }
      .close{
        width:50px;
        height:50px;
        background:url('../assets/img/icon_close.png') no-repeat center center / 60% 60%;
      }
    }
  }
}
</style>
